module.exports = __webpack_public_path__ + "static/img/ddztxq.3b0e100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ddztxq.jpg
// module id = xDRX
// module chunks = 4